import { EventMap } from "@/types/Events";

export function dispatchEvent<K extends keyof EventMap>(
  eventName: K,
  detail?: EventMap[K],
): void {
  const event = new CustomEvent(eventName, {
    bubbles: true,
    composed: true,
    detail,
  });

  globalThis.dispatchEvent(event);
}
